export const ROUTES_STANDARDS = {
  'iso-9001': 'iso-9001-quality-management-systems-qms',
  'iso-14001': 'iso-14001-environmental-management-system-ems',
  'iso-13485': 'iso-13485-medical-devices-management-system-mdms',
  'iso-22000': 'iso-22000-food-safety-management-system-fsms',
  'iso-iec-27001': 'iso-27001-information-security-management-isms',
  'iso-45001': 'iso-45001-health-and-safety-management-systems-ohs',
  'iso-50001': 'iso-50001-energy-management-systems-enms',
};
